
import { COVERGO_SAAS_DEV, COVERGO_ASIA_PRE_PROD } from "../consts.js"

export const msigih = {
	"msig-ih-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "msig_ih",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV
	},
	"msig-ih-studio.preprod.asia.covergo.cloud": {
		appConfig: {
			tenantId: "msigih_preprod",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_ASIA_PRE_PROD,
		fileSystem: {
			bucketName: "covergo-apse1-preprod-msigih-preprod"
		}
	}
}
